export const PauseIcon: React.FC = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="36"
			height="36"
			viewBox="0 0 36 36"
			fill="none"
		>
			<path
				d="M14.4476 23.1316H16.4999V12.8684H14.4476V23.1316ZM19.5001 23.1316H21.5524V12.8684H19.5001V23.1316ZM18.0024 31C16.2043 31 14.5142 30.6588 12.9321 29.9764C11.3499 29.294 9.97375 28.368 8.80353 27.1982C7.6333 26.0284 6.70676 24.6528 6.02392 23.0714C5.34131 21.4899 5 19.8003 5 18.0024C5 16.2043 5.34119 14.5142 6.02358 12.9321C6.70596 11.3499 7.63204 9.97375 8.80182 8.80353C9.97159 7.6333 11.3472 6.70676 12.9286 6.02392C14.5101 5.34131 16.1997 5 17.9976 5C19.7957 5 21.4858 5.34119 23.0679 6.02358C24.6501 6.70596 26.0262 7.63204 27.1965 8.80182C28.3667 9.97159 29.2932 11.3472 29.9761 12.9286C30.6587 14.5101 31 16.1997 31 17.9976C31 19.7957 30.6588 21.4858 29.9764 23.0679C29.294 24.6501 28.368 26.0262 27.1982 27.1965C26.0284 28.3667 24.6528 29.2932 23.0714 29.9761C21.4899 30.6587 19.8003 31 18.0024 31ZM18 28.9474C21.0561 28.9474 23.6447 27.8868 25.7658 25.7658C27.8868 23.6447 28.9474 21.0561 28.9474 18C28.9474 14.9439 27.8868 12.3553 25.7658 10.2342C23.6447 8.11316 21.0561 7.05263 18 7.05263C14.9439 7.05263 12.3553 8.11316 10.2342 10.2342C8.11316 12.3553 7.05263 14.9439 7.05263 18C7.05263 21.0561 8.11316 23.6447 10.2342 25.7658C12.3553 27.8868 14.9439 28.9474 18 28.9474Z"
				fill="#637381"
			/>
		</svg>
	);
};
